import React from 'react';
import { ICONS } from '../data/icons';

function fmtDist(km, useMetric) {
  if (useMetric) return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(2)} km`;
  const mi = km * 0.621371;
  return mi < 0.1 ? `${Math.round(mi * 5280)} ft` : `${mi.toFixed(2)} mi`;
}

export default function POICard({ poi, index, useMetric, onNameChange, onIconClick, onFocus, onRemove }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
      background: 'var(--surface)', border: '1.5px solid var(--border)',
      borderRadius: 'var(--r-md)', transition: 'border-color .18s, box-shadow .18s',
    }}>
      <div style={{
        width: 26, height: 26, background: 'var(--accent)', borderRadius: 'var(--r-sm)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 11, fontWeight: 700, color: '#fff', flexShrink: 0,
      }}>{index + 1}</div>

      <button
        onClick={() => onIconClick(poi.id)}
        title="Change icon"
        style={{
          width: 32, height: 32, background: '#1e293b', borderRadius: 'var(--r-sm)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', flexShrink: 0, border: 'none',
        }}
      >
        <svg viewBox="0 0 24 24" style={{ width: 16, height: 16, fill: '#fff' }}
          dangerouslySetInnerHTML={{ __html: ICONS[poi.iconKey]?.svg || ICONS.marker.svg }} />
      </button>

      <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
        <input
          type="text"
          value={poi.name}
          onChange={(e) => onNameChange(poi.id, e.target.value)}
          style={{
            width: '100%', background: 'transparent', border: 'none',
            fontFamily: 'var(--font)', fontSize: 13, fontWeight: 500, color: 'var(--text-1)',
            outline: 'none', padding: '1px 0', borderBottom: '1.5px solid transparent',
            textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', display: 'block',
          }}
          onFocus={e => e.target.style.borderBottomColor = 'var(--accent)'}
          onBlur={e => e.target.style.borderBottomColor = 'transparent'}
        />
        <div style={{ fontSize: 11, color: 'var(--text-3)', display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
          <svg viewBox="0 0 24 24" style={{ width: 10, height: 10, fill: 'currentColor', flexShrink: 0 }}>
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
          </svg>
          {ICONS[poi.iconKey]?.label || 'POI'}
          {poi.distance !== undefined && (
            <><span>·</span><span>{fmtDist(poi.distance, useMetric)}</span></>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 4, alignItems: 'center', flexShrink: 0 }}>
        <button
          onClick={() => onFocus(poi.id)}
          title="Focus"
          style={{
            padding: 5, background: 'var(--surface)', border: '1.5px solid var(--border)',
            color: 'var(--text-2)', borderRadius: 'var(--r-sm)', cursor: 'pointer', display: 'flex',
          }}
        >
          <svg viewBox="0 0 24 24" style={{ width: 13, height: 13, fill: 'currentColor' }}>
            <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
          </svg>
        </button>
        <button
          onClick={() => onRemove(poi.id)}
          title="Remove"
          style={{
            padding: 4, background: 'transparent', border: 'none', color: 'var(--text-3)',
            borderRadius: 'var(--r-sm)', cursor: 'pointer', display: 'flex',
          }}
        >
          <svg viewBox="0 0 24 24" style={{ width: 14, height: 14, fill: 'currentColor' }}>
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
